import Api from '@/services/Api'

export default {
	index (groupId) {
		return Api().get('clientsgroup', groupId)
	},
	show (clientsGroupId) {
		return Api().get(`clientsgroup/${clientsGroupId}`)
	},
	showClientInGroups (clientId) {
		return Api().get(`clientsgroup/membership/${clientId}`)
	},
	remove(clientsGroupId) {
		return Api().delete(`clientsgroup/${clientsGroupId}`)
	},
	post (clientsGroup) {
		return Api().post('clientsgroup', clientsGroup)
	}

}




// WEBPACK FOOTER //
// ./src/services/ClientsGroupService.js